import { useRef, useState } from "react";

import LeftSection from "./LeftSection11";
import RightSection from "./RightSection11";
import MessageCallingSection from "./MessageCallingSection11";
import { useEffect } from "react";
import { useGetState } from "../../context/useGetState";
import FullPageLoader from "../../components/full-page-loader";
import BottomNavigationForMobile from "./BottomNavigationForMobile";
import { getChatInteractingUsers, socketHost } from "./service";
import { io } from "socket.io-client";
import axios from "axios";
import { useDisclosure } from "@chakra-ui/hooks";
import { Collapse } from "@chakra-ui/transition";
import { useParams } from "react-router";

function Messaging() {
  const { state } = useGetState();
  const { userInfo, privateChatRecipient } = state;
  const { privateUserId } = useParams();
  const thePrivateChatUser = localStorage.getItem("privateChatRecipient")
    ? JSON.parse(localStorage.getItem("privateChatRecipient"))
    : undefined;
  const [showCall, setShowCall] = useState(false);
  const [chats, setChats] = useState(null);
  const [loading, setLoading] = useState(true);
  const accountType = userInfo?.account_type;
  const [selectedChat, setSelectedChat] = useState(null);
  const [activeState, setActiveState] = useState(0);
  const [contacts, setContacts] = useState([]);
  const [privateContact, setPrivateContact] = useState();
  const [traders, setTraders] = useState([]);
  const [currentChat, setCurrentChat] = useState(undefined);
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [typingUserId, setTypingUserId] = useState();

  const socket = useRef();
  // Get the bearer token from sessionStorage
  const token = sessionStorage.getItem("#f8WEB#");

  // Define headers with the bearer token
  const headers = {
    Authorization: `Bearer ${token}`,
    // Other headers if needed
  };

  //add authUser to socket socket, add-user event
  useEffect(() => {
    if (userInfo) {
      socket.current = io(socketHost); //one-to-one
      socket.current.emit("add-user", userInfo?.id); //emit event

      socket.current.on("getOnlineUsers", (res) => {
        setOnlineUsers(res);
      });
    }

    //clean-up
    return () => {
      socket.current?.off("getOnlineUsers");
    };
  }, [userInfo, socket]);

  useEffect(() => {
    async function fetchContacts() {
      if (privateUserId && thePrivateChatUser) {
        setContacts([thePrivateChatUser]); //obj to array
        setLoading(false);
      } else {
        const res = await axios.get(getChatInteractingUsers, { headers });
        setContacts(res?.data?.data);
        setLoading(false);
      }
    }
    fetchContacts();
  }, [userInfo]);

  const handleChatChange = (chat) => {
    setCurrentChat(chat);
  };

  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: true });
  const [isLeftSideVisible, setIsLeftSideVisible] = useState(true);

  const toggleLeftSide = () => {
    setIsLeftSideVisible((prevState) => !prevState);
  };
  return loading ? (
    <FullPageLoader />
  ) : (
    <BottomNavigationForMobile active={activeState}>
      <Collapse in={isOpen}>
        <LeftSection
          contacts={contacts}
          privateContact={privateContact}
          onlineUsers={onlineUsers}
          typingUserId={typingUserId}
          flex={["3", "3", "4", "2"]}
          maxW={["100%", "300px"]}
          w={["100%", "300px"]}
          accountType={accountType}
          chats={chats}
          setChats={setChats}
          privateChatRecipient={thePrivateChatUser}
          setSelectedChat={(data) => {
            console.log("ll");
            setSelectedChat(data);
            setActiveState((prev) => !prev);
          }}
          selectedChat={selectedChat}
          currentChat={currentChat}
          changeChat={handleChatChange}
        />
      </Collapse>

      {!showCall && (
        <RightSection
          onToggle={onToggle}
          socket={socket}
          typingUserId={typingUserId}
          setShowCall={setShowCall}
          h={["unset", window.innerHeight - 105]}
          w={["100%", "unset"]}
          accountType={accountType}
          privateChatRecipient={thePrivateChatUser}
          authUser={userInfo}
          chats={chats}
          selectedChat={selectedChat}
          currentChat={currentChat}
          setActiveState={setActiveState}
        />
      )}
      {showCall && <MessageCallingSection setShowCall={setShowCall} />}
    </BottomNavigationForMobile>
  );
}

export default Messaging;
